import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RubricaCreadaType {
	actividadRubricaIndividualKey: string;
	actividadRubricaGrupalKey: string;
	sesionKey: string;
}

const initialState: RubricaCreadaType = {
	actividadRubricaIndividualKey: '',
	actividadRubricaGrupalKey: '',
	sesionKey: ''
};

const rubricaCreadaStateSlice = createSlice({
	name: 'rubricaCreadaState',
	initialState,
	reducers: {
		setRubricaCreadaState: (state, action: PayloadAction<RubricaCreadaType>) => {
			const rubricaCreadaState = action.payload;
			return { ...state, rubricaCreadaState };
		}
	}
});

export const { setRubricaCreadaState } = rubricaCreadaStateSlice.actions;

export default rubricaCreadaStateSlice.reducer;
